import { defineStore } from "pinia";
import { useUserStore } from "@/stores/user";

export const useCobrowse = defineStore("cobrowse", {
  state: () => ({ isActive: false }),
  actions: {
    // manual call
    async endCobrowse() {
      if (!window.CobrowseIO.end) return;
      await window.CobrowseIO.end();
    },

    async startCobrowse({ onActive }) {
      await this.loadCobrowse();

      await window.CobrowseIO.client();
      await window.CobrowseIO.start();

      window.CobrowseIO.on("session.updated", e => {
        if (e.isActive() !== this.isActive) {
          this.isActive = e.isActive();
          if (this.isActive) onActive();
        }
      });

      window.CobrowseIO.on("session.ended", () => this.endCobrowse());

      const code = await window.CobrowseIO.createSessionCode();

      return code;
    },

    loadCobrowse() {
      return new Promise((resolve, reject) => {
        const user = useUserStore();

        if (document.getElementById("cobrowse-io")) {
          resolve();
          return;
        }

        window.CobrowseIO = {
          license: user.loginable.marketing_manager?.cobrowse_license,
          customData: {
            user_id: user.id,
            user_name: user.loginable.name,
            user_email: user.email
          },
          registration: false
        };

        const script = document.createElement("script");
        script.defer = true;
        script.id = "cobrowse-io";
        script.type = "text/javascript";
        script.src = "https://js.cobrowse.io/CobrowseIO.js";
        script.onload = () => resolve();
        script.onerror = () => reject();

        document.head.appendChild(script);
      });
    }
  }
});
